import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ENUMS from '../../../enums/index';
import * as cafeEventsActions from '../../../redux/cafeEvents/actions';
import Spin from '../../../components/loading';
import CafeEventDetails from '../modals/cafeEventDetails';
import ShowForPermission from '../../../components/ShowForPermission';
import { enumHelper, domManipulator } from '../../../utils';
import generateClassName from '../../../utils/generateClassName';

class ArchivedCafeEventsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      srotType: 'desc',
      archivedCafeEventOpen: false,
      selectedArchivedCafeEventId: null,
      status: '',
      sortedColumn: '',
      isActive: false
    };
  }

  displayArchivedCafeEventModal = id => {
    let { archivedCafeEventsList } = this.props;
    let selectedArchivedCafeEventId = archivedCafeEventsList.filter(request => request.id == id)[0].id;
    this.setState({ archivedCafeEventOpen: true, selectedArchivedCafeEventId });
  };

  closeArchivedCafeEventModal = () => {
    const query = this.props.buildSearchQuery(this.props.pageNumber,this.props.pageSize);
    this.props.fetchAllArchivedCafeEvents(query).then(() => {
      const { archivedCafeEventsError, archivedCafeEventsFailed, archivedCafeEventsMessage } = this.props;
      if (
        archivedCafeEventsError == false &&
        archivedCafeEventsFailed == false &&
        archivedCafeEventsMessage == null
      ) {
        this.setState(() => ({
          archivedCafeEventOpen: false
        }));
      } else {
        domManipulator.scrollToTop();
      }
    });
  };

  renderStatusColors = status => {
    const { CONFIRMED, DISABLED, REJECTED, REQUESTED } = ENUMS.EVENT_STATUS.values;
    switch (status) {
      case CONFIRMED:
        return 'text-success';
      case DISABLED:
        return 'text-muted';
      case REJECTED:
        return 'text-danger';
      case REQUESTED:
        return 'text-info';
      default:
        return 'text-dark';
    }
  };

  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.props.sortTable(query);
  };

  render() {
    let {
      archivedCafeEventsList = [],
      pageNumber,
      pageSize,
      sortType,

      archivedCafeEventsLoading,
      archivedCafeEventsMessage,
      archivedCafeEventsError,
      archivedCafeEventsFailed
    } = this.props;
    return (
      <>
        <Spin spinning={archivedCafeEventsLoading}>
          {archivedCafeEventsError && (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          )}
          {archivedCafeEventsFailed && <div className="alert alert-danger">{archivedCafeEventsMessage}</div>}
          <table className="table table-hover table-light table-striped">
            <thead>
              <tr>
                <th className="text-center">{locales('tables.row')}</th>
                <th onClick={() => this.sortTable('cafeName')} className="text-center pointer">
                  <i
                    name="cafeName"
                    className={generateClassName('cafeName', this.state.sortedColumn, sortType)}
                  />
                  {locales('fields.cafe.name')}
                </th>
                <th onClick={() => this.sortTable('name')} className="text-center pointer">
                  <i name="name" className={generateClassName('name', this.state.sortedColumn, sortType)} />
                  {locales('tables.title')}
                </th>
                <th onClick={() => this.sortTable('fromDate')} className="text-center pointer">
                  <i
                    name="fromDate"
                    className={generateClassName('fromDate', this.state.sortedColumn, sortType)}
                  />
                  {locales('labels.from.date')}
                </th>
                <th onClick={() => this.sortTable('toDate')} className="text-center pointer">
                  <i
                    name="toDate"
                    className={generateClassName('toDate', this.state.sortedColumn, sortType)}
                  />
                  {locales('labels.to.date')}
                </th>
                <th className="text-center">{locales('fields.weed.days')}</th>
                <th className="text-center">{locales('tables.status')}</th>
                <th className="text-center"></th>
              </tr>
            </thead>
            <tbody>
              {archivedCafeEventsList.length ? (
                archivedCafeEventsList.map((cafeEvent, index) => (
                  <tr key={cafeEvent.id}>
                    <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td className="text-center">{cafeEvent.cafeName}</td>
                    <td className="text-center">{cafeEvent.name}</td>
                    <td className="text-center">{cafeEvent.fromDate}</td>
                    <td className="text-center">{cafeEvent.toDate}</td>
                    <td className={`text-center`}>{cafeEvent.weekdays}</td>
                    <td className={`text-center ${this.renderStatusColors(cafeEvent.status)}`}>
                      {enumHelper.convertEnumValueToTitle(ENUMS.EVENT_STATUS.list, cafeEvent.status)}
                    </td>
                    <td title={locales('titles.eventDetails')} className="pointer text-center">
                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_EVENT_DETAILS}>
                        <i
                          onClick={() => this.displayArchivedCafeEventModal(cafeEvent.id)}
                          className="far fa-info-circle"
                        />
                      </ShowForPermission>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="col-12 text-center">
                  <td className="alert alert-info" colSpan={12}>
                    {locales('alerts.noRecord')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {this.state.archivedCafeEventOpen && (
            <CafeEventDetails
              isFromArchived={true}
              isOpen={this.state.archivedCafeEventOpen}
              eventId={this.state.selectedArchivedCafeEventId}
              closeModal={this.closeArchivedCafeEventModal}
            />
          )}
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    archivedCafeEventsList: state.cafeEventsReducer.archivedCafeEventsList,
    archivedCafeEvents: state.cafeEventsReducer.archivedCafeEvents,
    archivedCafeEventsFailed: state.cafeEventsReducer.archivedCafeEventsFailed,
    archivedCafeEventsError: state.cafeEventsReducer.archivedCafeEventsError,
    archivedCafeEventsMessage: state.cafeEventsReducer.archivedCafeEventsMessage,
    archivedCafeEventsLoading: state.cafeEventsReducer.archivedCafeEventsLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllArchivedCafeEvents: query => dispatch(cafeEventsActions.fetchAllArchivedCafeEvents(query))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ArchivedCafeEventsTable)
);
